import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import ReviewsIcon from '@mui/icons-material/Reviews';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { CreateCategoryInput, EditCategoryInput } from '__generated__/graphql';
import { useCreateCategory } from 'api/hooks/useCategory';
import { LocationBar } from 'components';
import { useToastNofication } from 'context/toastContext';
import { CategoryForm } from './CategoryForm';

function CategoryCreateForm() {
  const { createCategory, createCategoryLoading, createCategoryError } = useCreateCategory();
  const navigate = useNavigate();
  const { addToast } = useToastNofication();

  const onSubmit = async (input: CreateCategoryInput | EditCategoryInput) => {
    const response = await createCategory({
      variables: {
        input,
      },
    });
    addToast(response, 'CreateCategory');

    if (!createCategoryLoading && !createCategoryError) {
      navigate('/categories');
    }
  };

  return (
    <>
      <Helmet>
        <title>Category Create</title>
      </Helmet>
      <LocationBar section="Category" page="Category Create Form" Icon={ReviewsIcon} />
      <div className="my-10 px-4 md:px-[5%]">
        <button
          data-cy="form-detail-back"
          type="button"
          className="text-gray-500 font-semibold text-md leading-md flex items-center"
          onClick={() => navigate('/categories')}
        >
          <ArrowLeftIcon className="mr-2 w-5 h-5" /> Back
        </button>
        <CategoryForm onSubmit={onSubmit} formSubmitting={createCategoryLoading} formSubmitError={createCategoryError} />
      </div>
    </>
  );
}

export default CategoryCreateForm;
